<div class="container-titleList" [attr.data-qaa]="event.event_id" class="sidebar-portfolio" [ngClass]="{'sidebar-portfolio-selected': isEventSelected()}">
  <div class="pb-2"><span class="text-titleListHeader" data-qaa="program-name">{{programName}}</span></div>
  <div>
    <span class="text-titleList"> {{ 'DISPATCH_LIST.PORTFOLIO_CARD.PERFORMANCE' | translate }} </span>
    <span class="text-subtitleList" [ngClass]="performance?.class" data-qaa="event-performance-percent">{{performance?.percentage}}</span>
  </div>
  <div>
    <span class="text-titleList"> {{ 'DISPATCH_LIST.PORTFOLIO_CARD.SITES' | translate }} </span>
    <span class="text-subtitleList" data-qaa="sites-count">{{sitesCount}}</span>
  </div>
  <div>
    <span class="text-titleList"> {{ 'DISPATCH_LIST.PORTFOLIO_CARD.REDUCTION' | translate }} </span>
    <span class="text-subtitleList" data-qaa="target-reduction">{{targetReduction?.value}} {{targetReduction?.uom}}</span>
  </div>
  <div>
    <span class="text-titleList"> {{ 'DISPATCH_LIST.PORTFOLIO_CARD.START' | translate }} </span>
    <span class="text-subtitleList" data-qaa="start">{{startTimeString}}</span>
  </div>
  <div>
    <span class="text-titleList"> {{ 'DISPATCH_LIST.PORTFOLIO_CARD.ENDS' | translate }} </span>
    <span class="text-subtitleList" data-qaa="end">{{endTimeString}}</span>
  </div>
  <dsy-loader *ngIf="isLoading()" class="loading-spinner" size="xx-small"></dsy-loader>
  <div *ngIf="!showSites && !isLoading()">
    <a href="#" data-qaa="show-sites" class="show-more" (click)="toggleSitesList(); $event.preventDefault();"
      style="text-decoration: underline;">
      {{ 'DISPATCH_LIST.PORTFOLIO_CARD.SHOW_SITES' | translate }}
      <mat-icon class="dropdown-chip-close-icon">keyboard_arrow_down
      </mat-icon>
    </a>
  </div>
  <div *ngIf="showSites && !isLoading()" style="gap: 10px; display: grid; padding-top: 16px;">
    <app-site-card *ngFor="let siteCardSpec of siteCardsSpec; let i = index" [siteCardSpec]="siteCardSpec" [event]="event"></app-site-card>
    <p class="text-no-event" *ngIf="siteCardsSpec.length === 0">{{ 'DISPATCH_LIST.PORTFOLIO_CARD.NO_EVENT_NODES' | translate }}</p>
  </div>
  <div  *ngIf="showSites&& !isLoading()">
   <a href="#" data-qaa="hide-sites" class="show-more" (click)="toggleSitesList(); $event.preventDefault();"
      style="text-decoration: underline;">
      {{ 'DISPATCH_LIST.PORTFOLIO_CARD.HIDE_SITES' | translate }}
      <mat-icon class="dropdown-chip-close-icon">keyboard_arrow_up
      </mat-icon>
    </a>
  </div>
</div>
